import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Thumbs, EffectFade, Manipulation } from 'swiper/modules';
import { CssVariableBreakpoints } from 'swiper-js-utils';
Swiper.use([
  Pagination,
  Navigation,
  Autoplay,
  CssVariableBreakpoints,
  Thumbs,
  EffectFade,
  Manipulation,
  /**
   * Register "disable: true" and "enable: true" events
   */
  function ({ on }) {
    on('breakpoint', (swiper, breakpointParams) => {
      if (breakpointParams.disabled) {
        swiper.el.dispatchEvent(new CustomEvent('swiper:disabled', {}));

        return;
      }

      swiper.el.dispatchEvent(new CustomEvent('swiper:enabled', {}));
    });
  },
]);

window.Swiper = Swiper;

window.dispatchEvent(new CustomEvent('swiper:ready', { detail: window.Swiper }));

import Alpine from 'alpinejs';

/**
 * Register x-swiper-wrapper directive
 */
Alpine.directive('swiper-wrapper', (el) => {
  el.classList.add('swiper-wrapper');
  Alpine.nextTick(() => {
    el.swiperClasses = [];

    Array.from(el.classList).forEach((clss) => {
      if (clss.substring(0, 6) === 'swiper') {
        el.swiperClasses.push(clss);
      }
    });

    el.swiperInstance.el.addEventListener('swiper:disabled', () => {
      el.swiperClasses?.forEach((clss) => {
        el.classList.remove(clss);
      });
    });

    el.swiperInstance.el.addEventListener('swiper:enabled', () => {
      el.swiperClasses?.forEach((clss) => {
        el.classList.add(clss);
      });
    });
  });
});

/**
 * Register x-swiper-slide directives
 */
Alpine.directive('swiper-slide', (el) => {
  el.classList.add('swiper-slide');
  Alpine.nextTick(() => {
    el.swiperClasses = [];

    Array.from(el.classList).forEach((clss) => {
      if (clss.substring(0, 6) === 'swiper') {
        el.swiperClasses.push(clss);
      }
    });

    el.swiperInstance.el.addEventListener('swiper:disabled', () => {
      el.swiperClasses?.forEach((clss) => {
        el.classList.remove(clss);
      });
    });

    el.swiperInstance.el.addEventListener('swiper:enabled', () => {
      el.swiperClasses?.forEach((clss) => {
        el.classList.add(clss);
      });
    });
  });
});

/**
 * Register x-swiper directive
 */
Alpine.directive('swiper', (el, { value, expression }, { Alpine, evaluate }) => {
  el.classList.add('swiper');

  Alpine.nextTick(() => {
    try {
      el.swiperInstance = new Swiper(el, value === 'config' ? evaluate(expression) : {});

      el.dispatchEvent(new CustomEvent('swiper:ready', { detail: el.swiperInstance }));

      el.swiperInstance.wrapperEl.swiperInstance = el.swiperInstance;
      el.swiperInstance.slides.forEach((slide) => {
        slide.swiperInstance = el.swiperInstance;
      });

      el.swiperInstance.el.addEventListener('swiper:disabled', () => {
        el.swiperInstance.disable();

        let swiperClasses = [];

        Array.from(el.classList).forEach((clss) => {
          if (clss.substring(0, 6) === 'swiper') {
            swiperClasses.push(clss);
            el.classList.remove(clss);
          }
        });

        el.swiperClasses = swiperClasses;
      });

      el.swiperInstance.el.addEventListener('swiper:enabled', () => {
        el.swiperClasses?.forEach((clss) => {
          el.classList.add(clss);
        });

        el.swiperInstance.enable();
      });
    } catch (error) {
      console.error(error);
    }
  });
});
